import { Injectable } from '@angular/core';
import { RestHttpService } from '@catmodules/core/services/rest-http.service';
import { AircraftRegistration } from '@catmodules/models/userdata-generation/types';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class AircraftRegistrationService extends RestHttpService<AircraftRegistration> {

  constructor(service: Restangular) {
    super('aircraft-registrations', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/userdata-generation/services/aircraft-registration.service.ts